module.exports = __webpack_public_path__ + "static/img/mahal.35f758d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/mahal.jpg
// module id = /ZcK
// module chunks = 1